import React from "react";
import ChatPdfArtifactPane from "./ChatPdfArtifactPane";
import ChatZipBundleArtifactPane from "./ChatZipBundleArtifactPane";
import ChatZipBinaryArtifactPane from "./ChatZipBinaryArtifactPane";

/**
 * Routes the right-hand artifact panel by active artifact kind (PDF vs ZIP bundle vs ZIP blob).
 */
export default function ChatArtifactPane({
  activeArtifact,
  onOpenPdfAttachment,
  overlayMode = false,
  onClose,
}) {
  if (!activeArtifact) return null;

  const paneProps = { overlayMode, onClose };

  if (activeArtifact.kind === "pdf") {
    return <ChatPdfArtifactPane attachment={activeArtifact.attachment} {...paneProps} />;
  }

  if (activeArtifact.kind === "zipBundle") {
    return (
      <ChatZipBundleArtifactPane
        assetBundle={activeArtifact.assetBundle}
        pdfAttachment={activeArtifact.pdfAttachment}
        uploadedAssets={activeArtifact.uploadedAssets}
        onOpenPdfAttachment={onOpenPdfAttachment}
        {...paneProps}
      />
    );
  }

  if (activeArtifact.kind === "zipBlob") {
    return (
      <ChatZipBinaryArtifactPane
        attachment={activeArtifact.attachment}
        onOpenPdfAttachment={onOpenPdfAttachment}
        {...paneProps}
      />
    );
  }

  return null;
}
